// extracted by css-extract-rspack-plugin
export default {"initial":"initial-QDn6MT","red":"red-NhPI0y"};